var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":_vm.unreadNotification.view_route}},[_vm._v(_vm._s(_vm.unreadNotification.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }